
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inc-package",
      function () {
        return require("private-next-pages/inc-package.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inc-package"])
      });
    }
  